"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/echarts/index"));
var _statistic = require("@/api/statistic");
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    echartsFrom: _index.default,
    countTo: _vueCountTo.default
  },
  data: function data() {
    return {
      xAxis: [],
      yAxis: {
        type: 'value'
      },
      series: [{
        data: [150, 230, 224, 218, 135, 147, 260],
        type: 'line'
      }],
      dataTitlelist: [{
        name: '待发货单量',
        value: ''
      }, {
        name: '待审核售后',
        value: ''
      }, {
        name: '进行中售后数量',
        value: ''
      }, {
        name: '库存紧张商品',
        value: ''
      }],
      dataRight: [{
        name: '总单量',
        value: ''
      }, {
        name: '总金额',
        value: ''
      }, {
        name: '客单价',
        value: ''
      }, {
        name: '消耗福豆总额',
        value: ''
      }, {
        name: '售后单量',
        value: ''
      }, {
        name: '售后总金额',
        value: ''
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _statistic.getOperationData)().then(function (res) {
      var echartOrderList = res.echartOrderList;
      _this.xAxis = echartOrderList.map(function (_ref) {
        var date = _ref.date;
        return date;
      });
      _this.series[0].data = echartOrderList.map(function (_ref2) {
        var totalPrice = _ref2.totalPrice;
        return totalPrice;
      });
      console.log(_this.series[0].data);
      var titleDataMap = {
        '待发货单量': res.pendingShippingOrderNum,
        '待审核售后': res.pendingAuditAfterSaleOrderNum,
        '进行中售后数量': res.doingAfterSaleOrderNum,
        '库存紧张商品': res.stockWarningNum
      };
      _this.dataTitlelist.forEach(function (item) {
        item.value = titleDataMap[item.name] || '';
      });
      var rightDataMap = {
        '总单量': res.totalOrderNum,
        '总金额': res.totalOrderAmount,
        '客单价': res.averageOrderAmount,
        '消耗福豆总额': res.totalFudouAmount,
        '售后单量': res.afterSaleOrderNum,
        '售后总金额': res.afterSaleOrderAmount
      };
      _this.dataRight.forEach(function (item) {
        item.value = rightDataMap[item.name] || '';
      });
    });
  },
  methods: {}
};